






































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import gridFormat from '@/utils/gridFormat'
import skyconText from '@/utils/skyconText'
import ForecastData from '@/service/ForecastData'
import { Icon, Toast } from 'vant';
const weekArr = ['日', '一', '二', '三', '四', '五', '六']
export default Vue.extend({
  components: {
    Icon
  },
  props: {
    data: { type: Object },
    address:{type: String}
  },
  data() {
    return {
      warnInfos: [],
      adminCode: config.defaultStationObj.adminCode
    }
  },
  methods: {
    getSkyconText(value:any){
      return skyconText.skyconText(value)
    },
    async getData() {
      const lng = config.defaultStationObj.lon
      const lat = config.defaultStationObj.lat
      let wpdata: any[] = []
      await ForecastData.get12hours(lat, lng).then((res) => {
        // console.log(res)
        wpdata = res
      })
      ForecastData.getDaily(lat, lng).then((res) => {
        res.map((e: any, index: any) => {
          const t1 = moment().add(index, 'd').format('YYYYMMDD')
          const t2 = moment().add(index + 1, 'd').format('YYYYMMDD')
          if (!wpdata || wpdata.length === 0) { return }
          let wp1 = null
          let wp2 = null
          wpdata.map((i) => {
            const { dataTime, wp12 } = i
            if (dataTime === `${t1}200000`) { wp1 = wp12 }
            else if (dataTime === `${t2}080000`) { wp2 = wp12 }
          })
          e.wp = [wp1, wp2]
        })
        res.map((e: any) => {
          e.weekStr = `周${weekArr[moment(e.time).day()]}`
          e.date = moment(e.time, 'YYYYMMDDHH').format('MM/DD')
          const str1 = !e.wp[0] && e.wp[0] !== 0 ? '--' : e.wp[0] < 10 ? `d0${e.wp[0]}` : `d${e.wp[0]}`
          const str2 = !e.wp[1] && e.wp[1] !== 0 ? '--' : e.wp[1] < 10 ? `d0${e.wp[1]}` : `d${e.wp[1]}`
          const desc1 = e.wp[0] === 0 ? skyconText.weatherIcon(str1) : !e.wp[0] ? '--' : skyconText.weatherIcon(str1)
          const desc2 = e.wp[1] === 0 ? skyconText.weatherIcon(str2) : !e.wp[1] ? '--' : skyconText.weatherIcon(str2)
          e.wpDesc = desc1 === desc2 ? desc1 : `${desc1}转${desc2}`
          e.wpImage = e.wp[0] === 0 ? `/static/weatherIcon/d0${e.wp[0]}.png` : !e.wp[0] ? '/static/weatherIcon/--.png' : e.wp[0] < 10 ? `/static/weatherIcon/d0${e.wp[0]}.png` : `/static/weatherIcon/d${e.wp[0]}.png`
        })
        console.log(res.slice(1, 8))
      })

    },
    getSkyCon(wp: number) {
      return gridFormat.formatSkyConIcon(wp)
    },
    getDesc(wp: number) {
      return gridFormat.formatWeather(wp)
    }

  },
  filters: {
    dtFormat(datetime: number) {
      const time = moment(datetime, 'YYYYMMDDHHmmss')
      return time.add(8, 'hours').format('YYYY年M月D日')
    }
  }
})
